import { Solution } from '@audibene/ta.utils-opportunity'

type DeprecatedSolution = Extract<Solution, 'ADVANTAGE' | 'DIRECT_SALE' | 'MEDICAL_ADVANTAGE'>
type NonDeprecatedSolution = Exclude<Solution, DeprecatedSolution>

const NonDeprecatedSolution: { [Solution in NonDeprecatedSolution]: Solution } = {
  BEST_CHOICE: Solution.BEST_CHOICE,
  ECONOMY: Solution.ECONOMY,
  HEAR_TODAY: Solution.HEAR_TODAY,
  MEDICARE_ADVANTAGE: Solution.MEDICARE_ADVANTAGE,
  OVER_THE_COUNTER: Solution.OVER_THE_COUNTER,
  RETAIL: Solution.RETAIL,
  STANDARD: Solution.STANDARD,
  TRUHEARING: Solution.TRUHEARING,
  YOUNG_HEARING_AID: Solution.YOUNG_HEARING_AID,
} as const

export { NonDeprecatedSolution, Solution }
